import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';

import { catalogBibShape, libraryShape, listShape, userIdentityShape } from '@bibliocommons/bc-prop-types';

import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectStaffListsForCurrentBib } from 'app/selectors/bibs/DiscoverySelector';
import { selectUserEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';

import StaffLists from './StaffLists';

export class StaffListsContainer extends React.PureComponent {
  render() {
    return <StaffLists {...this.props} />;
  }
}

StaffListsContainer.propTypes = {
  catalogBib: catalogBibShape,
  users: ImmutablePropTypes.mapOf(userIdentityShape),
  lists: ImmutablePropTypes.listOf(listShape).isRequired,
  library: libraryShape
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  users: selectUserEntities(state),
  lists: selectStaffListsForCurrentBib(state),
  library: selectCurrentLibrary(state)
});

export default connect(mapStateToProps)(StaffListsContainer);
